// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import { staticListProductListLineStyles } from "@awc/Overrides/Widgets/StaticList/StaticListProductListLine";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { displayFlexOnPrint, mergeWithCss, sharedProductDescriptionStyles } from "@awc/XDL/Utilities";
import { xScreen } from "@awc/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

staticListProductListLineStyles.imageWrapper = {
    css: css`
        width: 120px;
        height: 120px;
        justify-content: center;
        ${xScreen("lte", "md")} {
            width: 99px;
            height: 99px;
        }
    `,
};

staticListProductListLineStyles.productPartNumbersStyles = {
    ...mergeWithCss(cartLineSharedStyles.productPartNumbers, {
        container: {
            css: css`
                margin-bottom: 0;
            `,
        },
    }),
};

staticListProductListLineStyles.productAvailabilityStyles = {
    container: {
        css: css`
            margin-bottom: 8px;
        `,
        offsetCss: css`
            & > div:empty {
                display: none;
            }
        `,
    },
    errorWrapper: {
        css: css`
            margin-bottom: 12px;
        `,
    },
    messageGridItem: {
        width: 12,
        css: css`
            ${displayFlexOnPrint}
        `,
    },
};

staticListProductListLineStyles.productUnitOfMeasureSelectStyles = {
    labelProps: {
        css: css`
            display: none;
            @media print {
                display: block;
            }
        `,
    },
    sizeVariant: "small",
    cssOverrides: {
        inputSelect: css`
            margin: 0;
        `,
        formField: css`
            width: auto;
            ${IconWrapper} {
                background: none;
            }
        `,
    },
};

staticListProductListLineStyles.addToListLink = {
    link: {
        ...cartLineSharedStyles.addToListLink,
    },
};

staticListProductListLineStyles.productQuantityOrdered = {
    wrapper: {
        css: css`
            width: 70px;
            min-width: 70px;
            &&& input {
                height: 32px;
            }
        `,
    },
};

staticListProductListLineStyles.addToCartButton = {
    mergeCss: true,
    sizeVariant: "small",
    css: css`
        flex-grow: 1;
    `,
};

staticListProductListLineStyles.quantityAddtoCartWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        width: 100%;
        gap: 8px;
        justify-content: space-between;
        margin-bottom: 4px;
        @media print {
            flex-direction: column;
            align-items: flex-start;
            gap: 5px;
        }
    `,
};

staticListProductListLineStyles.productPriceStyles = {
    wrapper: {
        css: css`
            width: auto;
        `,
    },
    priceWrapper: {
        css: css`
            line-height: ${fontConfig.lineHeight.xSmall};
            margin-bottom: 4px;
        `,
    },
    price: {
        priceText: {
            size: 18,
            weight: fontConfig.weight.bold,
            lineHeight: "24px",
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: fontConfig.fontSize.xSmall,
                lineHeight: fontConfig.lineHeight.xxSmall,
                weight: fontConfig.weight.regular,
                css: css`
                    white-space: nowrap;
                `,
            },
        },
    },
};

staticListProductListLineStyles.productDescriptionStyles = {
    ...sharedProductDescriptionStyles(),
};

staticListProductListLineStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 120px;
            height: 120px;
            justify-content: center;
            ${xScreen("lte", "md")} {
                width: 99px;
                height: 99px;
            }
        `,
    },
    img: {
        css: css`
            aspect-ratio: 1;
            object-fit: contain;
        `,
    },
};

staticListProductListLineStyles.partNumbersSection = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        > ${StyledWrapper},>${TypographyStyle} {
            width: 50%;
        }
        ${xScreen("lte", "md")} {
            flex-direction: column;
            row-gap: 8px;
            > ${StyledWrapper},>${TypographyStyle} {
                width: 100%;
            }
        }
    `,
};
